import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router';
import UISpinner from 'Components/UIComponents/UISpinner';
import { useBeaconRemove } from 'Hooks/Common';
import { useDocumentGet } from 'Hooks/Document';
import { Document } from 'Interfaces/Document';
import StorageService from 'Services/Storage';
import { selectDocument } from 'Utils/selectors';

import LandingSignDocument from './LandingSignDocument';
import LandingSignUp from './LandingSignUp';

export enum StepType {
  SIGN = 'sign',
  SIGN_UP = 'sign_up',
}

type PageParams = {
  documentId: Document['id'];
};

const LandingSignUpWrapper = () => {
  useBeaconRemove();
  const location = useLocation();

  const params = useParams<PageParams>();
  const [stepType, setStepType] = useState<StepType>(StepType.SIGN);
  const [documentId, setDocumentId] = useState<Document['id'] | undefined>(
    params.documentId,
  );
  const document = useSelector(state => selectDocument(state, { documentId }));
  const [getDocument, isGettingDocument] = useDocumentGet();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('tempToken');

    if (token) {
      StorageService.setAccessToken(token, 'tempToken');
    }

    if (documentId) {
      getDocument({ documentId });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isGettingDocument && !document) {
    return <UISpinner wrapperClassName="spinner--main__wrapper" width={50} height={50} />;
  }

  return (
    <div className="sign-up-landing__wrapper">
      {stepType === StepType.SIGN && (
        <LandingSignDocument
          document={document}
          documentId={documentId}
          setDocumentId={setDocumentId}
          setStepType={setStepType}
        />
      )}
      {stepType === StepType.SIGN_UP && <LandingSignUp document={document} />}
    </div>
  );
};

export default LandingSignUpWrapper;
